<template>
  <div>
    <div
      :class="{
        'mb-3': !isDayView && !isTodayView,
      }"
    >
      <div class="row">
        <div v-if="!isTodayView" class="col-12 col-md-auto">
          <button
            v-if="!isMobile"
            type="button"
            class="btn-change-day mr-2"
            @click="changeDay(false)"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <button
            v-if="!isMobile"
            type="button"
            class="btn-change-day"
            @click="changeDay()"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        <div class="col-12 col-md-auto col-lg">
          <div
            class="btn-day-picker pointer"
            @click="openDatePicker"
            v-click-outside="closeDatePicker"
          >
            <div class="m-0 font-16 text-center font-weight-bold">
              <div class="date-range">
                <span v-if="isTodayView || isDayView">
                  {{ currentDate | date('dddd D [de] MMMM YYYY') }}
                </span>
                <span v-if="isWeekView">
                  {{ lisOfDays[0] | date('dddd D MMM') }} -
                  {{ lisOfDays[6] | date('dddd D MMM YYYY') }}
                </span>
                <span v-if="isMonthView">
                  {{ currentDate | date('MMMM YYYY') }}
                </span>
              </div>
              <div class="datepicker-container">
                <div class="date-range-icon" v-if="!isTodayView">
                  <i
                    :class="
                      isOpen ? `fas fa-chevron-down` : `fas fa-chevron-up`
                    "
                  />
                </div>
                <div v-if="isOpen" class="date-picker">
                  <custom-datepicker-vue2
                    :calendar-type="calendarType"
                    @calendar-input="setDatePickerValue"
                    :disabled-days="{
                      days: definedTime?.disabledDays.split(','),
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 mt-2 mt-xl-0">
          <div class="caats-wrapper">
            <div v-for="(item, key) in listOfCaats" :key="key">
              <button
                class="badge badge-pill px-4 py-2 mr-2"
                :style="{
                  background: isCaatSelected(item.id)
                    ? item.color
                    : secondaryColor(item.color),
                  border: `1px solid ${item.color}`,
                }"
                @click="$emit('change-caat', item)"
              >
                <div class="d-flex align-items-center">
                  <div class="mr-2">
                    <i
                      class="fas fa-map-marker-alt"
                      :style="{
                        color: isCaatSelected(item.id) ? 'white' : item.color,
                      }"
                    ></i>
                  </div>
                  <span
                    class="font-weight-bold font-14 text-capitalize"
                    :class="{
                      'text-white': isCaatSelected(item.id),
                      'text-dark': !isCaatSelected(item.id),
                    }"
                  >
                    {{ item.name }}
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMonthView || isWeekView" class="calendar-header">
      <div
        :key="key"
        v-for="(item, key) in lisOfDays"
        class="rounded p-3 week-day text-center"
      >
        <p class="m-0 font-16">{{ nameOfDays(item) }}</p>
        <p v-if="isWeekView" class="m-0 text-uppercase font-14">
          {{ item | date('DD MMM') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import CustomDatepickerVue2 from '@/components/common/CustomDatepicker-vue2.vue';

const CALEDAR_VIEWS = {
  TODAY: 1,
  DAY: 2,
  WEEK: 3,
  MONTH: 4,
};

export default {
  name: 'CalendarHeader',
  components: {
    CustomDatepickerVue2,
  },
  directives: {
    'click-outside': {
      bind: function(el, binding) {
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  props: {
    definedTime: {
      type: Object,
      default: () => null,
    },
    viewMode: {
      type: Number,
      default: 0,
    },
    currentDate: {
      type: Date,
      default: new Date(),
    },
    days: {
      type: Array,
      default: () => [],
    },
    caats: {
      type: Array,
      default: () => [],
    },
    selectedCaats: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    calendarType() {
      switch (this.viewMode) {
        case CALEDAR_VIEWS.DAY:
          return 'date';
        case CALEDAR_VIEWS.WEEK:
          return 'week';
        case CALEDAR_VIEWS.MONTH:
          return 'month';
        default:
          break;
      }
    },
    isTodayView() {
      return this.viewMode === CALEDAR_VIEWS.TODAY;
    },
    isDayView() {
      return this.viewMode === CALEDAR_VIEWS.DAY;
    },
    isWeekView() {
      return this.viewMode === CALEDAR_VIEWS.WEEK;
    },
    isMonthView() {
      return this.viewMode === CALEDAR_VIEWS.MONTH;
    },
    listOfCaats() {
      return this.caats.map((caat) => ({
        ...caat,
        name: caat.name.toLowerCase(),
      }));
    },
    nameOfDays() {
      return (date) => {
        const days = [
          'Domingo',
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
        ];
        return days[date.getDay()];
      };
    },
    lisOfDays() {
      return this.days.slice(0, 7);
    },
    isCaatSelected() {
      return (caatId) => this.selectedCaats.includes(caatId);
    },
    secondaryColor() {
      return (color) => {
        //hex to rgb
        let c = color.substring(1).split('');
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ', 0.15)'
        );
      };
    },
  },
  methods: {
    openDatePicker() {
      if (!this.isTodayView) {
        this.isOpen = true;
      }
    },
    closeDatePicker() {
      this.isOpen = false;
    },
    setDatePickerValue(newValue) {
      this.$emit('goToDay', newValue);
      this.closeDatePicker();
    },
    changeDay(future = true) {
      switch (this.viewMode) {
        case CALEDAR_VIEWS.WEEK:
          this.$emit('add-day', future ? 7 : -7);
          return;
        case CALEDAR_VIEWS.MONTH:
          this.$emit('add-month', future ? 1 : -1);
          return;
        default:
          this.$emit('add-day', future ? 1 : -1);
          return;
      }
    },
  },
};
</script>
<style scope lang="scss">
.calendar-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 15px;
}

.day-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}

.btn-change-day {
  background-color: #f4f6f3;
  border-radius: 4px;
  width: 45px;
  height: 45px;
  border: none;
}

.caats-wrapper {
  background-color: #f2f2f2;
  border-radius: 4px;
  padding: 7.5px 15px;
  display: flex;
  max-width: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.btn-day-picker {
  background-color: #d9e5df;
  border-radius: 4px;
  border: none;
  padding: 11px 15px;
}

.btn-content,
.caat-content,
.picker-content,
.picker-content-l {
  width: 100%;
}

@media (min-width: 992px) {
  .btn-content {
    flex: 0 0 auto;
  }
  .caat-content {
    flex: 0 0 60%;
  }
  .picker-content {
    width: 35%;
  }
  .picker-content-l {
    width: 40%;
  }
}

@media (min-width: 1200px) {
  /* En este punto, solo necesitas cambiar las propiedades que difieren */
  .btn-content,
  .caat-content {
    flex: 0 0 auto;
  }
}

.date-picker {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  margin-top: 40px;
}

.datepicker-container {
  display: contents;
}

.date-range {
  display: inline;
}

.date-range-icon {
  display: inline;
  margin: 2px;
  margin-left: 6px;
  cursor: pointer;
}

.caat-disable {
  background-color: #f2f2f2 !important;
  color: #3f5b60 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  border: 1px solid #9e9e9e !important;
}
.caat-disable-icon {
  color: #3f5b60 !important;
}
</style>
